/* eslint react/no-did-mount-set-state: 0 */

import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {selector} from '../../utils/wdio-selectors';

import TextAccordion from '../../components/common/text-accordion/TextAccordion';

const SEOTextComponent = ({
    baseCls = 'text-accordion',
    containerCls = 'seo-text',
    panelIDPrefix = 'seo-description-type',
    slpText,
    isRefined,
    moduleLoaded,
    moduleHidden,
}) => {
    const text = slpText.map(
        ({content, seoDescriptionType: panelID, type, title, titleTag}) => ({
            content,
            panelID,
            type,
            title,
            titleTag,
        })
    );

    useEffect(() => {
        if (!text.length) {
            moduleHidden('seo-accordion');
        } else {
            moduleLoaded('seo-accordion');
        }
    }, [moduleHidden, moduleLoaded, text.length]);

    const computedContainerCls = classNames(
        {
            'module--no-margin ': !text.length,
        },
        `${isRefined ? 'refined-' : ''}${containerCls}`
    );

    return (
        <TextAccordion
            baseCls={baseCls}
            containerCls={computedContainerCls}
            panelIDPrefix={panelIDPrefix}
            text={text}
            headingStyle={isRefined ? 'dynamic' : 'span'}
            dataWdio={selector.seoAccordion}
        />
    );
};

const slpTextItem = PropTypes.shape({
    content: PropTypes.string,
    seoDescriptionType: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    titleTag: PropTypes.string,
});

SEOTextComponent.propTypes = {
    baseCls: PropTypes.string,
    containerCls: PropTypes.string,
    panelIDPrefix: PropTypes.string,
    slpText: PropTypes.arrayOf(slpTextItem),
};

export default React.memo(SEOTextComponent);
